import React, { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";

import {
  FlexContainer,
  FlexDiv,
  DesktopContainer,
  MobileContainer,
} from "@/components/Atoms/Box";
import SVGSprite from "@/components/Atoms/SVGSprite";
import Button from "@/components/Atoms/Button";
import Ribbon, {
  RibbonPropsI,
} from "@/components/Organisms/Navbar/Header/Ribbon";
import Toast from "@/components/Molecules/Toast";
import ShyftMobileDrawer from "@/components/Molecules/MobileDrawer/ShyftPassMobileDrawer";

import menu, { ShyftPassPageMenu } from "@/constants/HeaderMenu";

import { getURLParams, isMobile } from "@/utils";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import { DropDownWrap, HeaderWrapper } from "./style";

interface HeaderPropsI {
  headerRef?: React.Ref<HTMLElement>;
  headerBackgroundColor?: String;
  hideLinks?: Boolean;
  isStickyHeader?: Boolean;
  isLandingPage?: Boolean;
  darkHeader?: Boolean;
  showSidebar?: Boolean;
  setShowSidebar?: (val: Boolean) => void;
  token?: String;
  Logout?: () => void;
  setLoginModal?: (val: Boolean) => void;
  appDownloadLink?: URL;
  showRibbon?: Boolean;
  ribbonData?: RibbonPropsI;
  showToast?: { message: String; type: String; duration: Number };
  setShowToast?: (val: Boolean) => void;
  login?: Boolean;
  loginModal?: Boolean;
  setLoginToken?: (val: Boolean) => void;
  countryCodes?: any[];
  isShyftPassBookingPage: boolean;
}

const Header: React.FC<HeaderPropsI> = ({
  headerRef,
  headerBackgroundColor,
  hideLinks,
  isStickyHeader,
  isLandingPage,
  darkHeader,
  showSidebar,
  setShowSidebar = () => {},
  token,
  Logout = () => {},
  setLoginModal = () => {},
  appDownloadLink = "",
  showRibbon,
  ribbonData = {},
  showToast,
  setShowToast = () => {},
  login,
  loginModal,
  setLoginToken = () => {},
  countryCodes,
  isShyftPassBookingPage,
}) => {
  const [showHeaderLinks, setShowHeaderLinks] = useState(false);
  const [showGoToShyftButton, setShowGoToShyftButton] = useState(false);

  useEffect(() => {
    const params = getURLParams();
    const search = document?.location?.search;
    const source = params?.get("source") || "";

    setShowHeaderLinks(true);
    if (source !== "app" && !search.includes("source=app")) {
      setShowGoToShyftButton(true);
    }
  }, []);

  return (
    <HeaderWrapper
      className="shyft-pass-header"
      ref={headerRef}
      boxShadow={
        !hideLinks
          ? headerBackgroundColor !== "transparent"
            ? `0px 13px 18px ${theme.colors.link2Color}0a`
            : "none"
          : "none"
      }
    >
      <FlexContainer
        alignItems="center"
        px={isMobile ? "16px" : "0"}
        justifyContent={isShyftPassBookingPage ? "center" : "space-between"}
      >
        <FlexDiv
          alignItems="center"
          minHeight={isMobile ? "38px" : "1px"}
          py={isMobile ? "8.5px" : "16px"}
          pt={
            !isStickyHeader && isLandingPage && !isMobile
              ? "32px"
              : isMobile
              ? "8.5px"
              : "16px"
          }
        >
          {/* <DesktopContainer> */}
          <Typography variant="routelink1" to="/shyftpass">
            <ShyftPassBrandLogo height={"43px"} width={"168px"} />
          </Typography>
          {/* </DesktopContainer> */}
          {/* <MobileContainer>
          <Typography variant="routelink1" to="/shyftpass">
            <ShyftPassBrandLogo height={"43px"} width={"150px"} />
          </Typography>
        </MobileContainer> */}
        </FlexDiv>
        <FlexDiv alignItems="center" style={{ gap: "24px" }}>
          {!hideLinks &&
            showHeaderLinks &&
            ShyftPassPageMenu?.map((menuItem, index) => (
              <DesktopContainer key={index}>
                <DropDownWrap
                  position="relative"
                  zIndex="9"
                  padding="18px 24px 18px 24px"
                  isLastElement={menu.length === index + 1}
                  darkHeader={darkHeader}
                >
                  {document?.getElementById(menuItem.link) ? (
                    <p
                      className="shyft-pass-header-menu-text"
                      onClick={() => {
                        document
                          ?.getElementById(menuItem.link)
                          ?.scrollIntoView({
                            behavior: "smooth",
                            block: "nearest",
                          });
                      }}
                    >
                      {menuItem.title}
                    </p>
                  ) : (
                    <Typography
                      variant="link1"
                      href={`/shyftpass#${menuItem.link}`}
                      className="shyft-pass-header-menu-text"
                      fontFamily="var(--dm-sans)"
                    >
                      {menuItem.title}
                    </Typography>
                  )}
                </DropDownWrap>
              </DesktopContainer>
            ))}
        </FlexDiv>
        {!isShyftPassBookingPage && (
          <FlexDiv id="shyft-pass-header-button">
            {showGoToShyftButton && (
              <Button
                variant="outline"
                onClick={() => window.open("/", "_blank")}
              >
                Go to Shyft
              </Button>
            )}
            {false && (
              <MobileContainer
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "43px",
                  width: "43px",
                  padding: "8px",
                  backgroundColor: "#282828",
                  borderRadius: "50%",
                }}
              >
                <SVGSprite
                  onClick={() => setShowSidebar(true)}
                  icon="icon-shyft-pass-menu-kabab-icon"
                  height="18.95px"
                  width="18.95px"
                  cursor="pointer"
                  //   fill={theme.colors.white}
                />
              </MobileContainer>
            )}
          </FlexDiv>
        )}
      </FlexContainer>
      {showRibbon && <Ribbon {...ribbonData} />}
      <AnimatePresence>
        {showSidebar && (
          <ShyftMobileDrawer
            onClose={() => setShowSidebar(false)}
            token={token}
            Logout={() => Logout()}
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {showToast && (
          <Toast
            text={showToast?.message}
            autoDismiss
            type={showToast?.type}
            duration={showToast?.duration}
            onClose={() => setShowToast(false)}
          />
        )}
      </AnimatePresence>
    </HeaderWrapper>
  );
};

export default Header;

function ShyftPassBrandLogo({ height, width }: any) {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_463_146)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1459 11.1869C16.5435 9.84814 14.4497 9.17878 11.8646 9.17878C9.31269 9.10392 6.8168 9.91644 4.82437 11.4707C3.93323 12.1219 3.20992 12.966 2.71162 13.9363C2.21332 14.9066 1.95369 15.9764 1.95326 17.0612C1.94416 18.5743 2.46399 20.0453 3.42732 21.2327C4.34883 22.4349 5.66453 23.2945 7.15646 23.6692L11.4631 24.7562C13.3607 25.2382 14.3067 26.0307 14.3067 27.1445C14.303 27.4027 14.2324 27.6557 14.1017 27.8804C13.971 28.105 13.7842 28.2939 13.5587 28.4297C13.0352 28.7903 12.4068 28.978 11.7656 28.9652C10.0716 28.9652 9.16403 28.2316 8.97152 26.7643H1.65625C1.73727 27.8788 2.04841 28.9659 2.57103 29.9605C3.09366 30.9551 3.81704 31.8369 4.69786 32.553C6.46526 33.981 8.72402 34.695 11.4741 34.695C14.1075 34.7844 16.6887 33.965 18.7619 32.3816C19.6739 31.7071 20.4125 30.8356 20.9193 29.8356C21.4262 28.8357 21.6874 27.7348 21.6825 26.6197C21.7278 25.289 21.343 23.9779 20.5825 22.8713C19.9888 22 19.1891 21.2801 18.2504 20.7722C16.6065 20.0594 14.8976 19.4982 13.1462 19.0961C10.6088 18.4178 9.34004 17.5432 9.34004 16.4722C9.34004 15.4512 10.1101 14.9407 11.6501 14.9407C12.9262 14.9407 13.6284 15.5297 13.7567 16.7078H20.907C20.8489 15.6546 20.5747 14.6235 20.1005 13.6752C19.6262 12.727 18.9616 11.8808 18.1459 11.1869ZM97.4863 0.166448H89.6596V9.24839H83.2463V8.23096C83.2426 6.63876 84.042 5.84266 85.6444 5.84266H86.5794V0.107544H85.3804C82.0583 0.136104 79.5722 0.778694 77.9221 2.03531C76.272 3.29194 75.447 5.25541 75.447 7.92573V9.26446H66.4322L61.372 23.9851L56.1083 9.26446H47.7755L57.4778 33.3616L53.3582 43.1075H61.6085L72.5539 14.7961V14.9835H75.425V34.6307H83.2463V14.9835H89.6596V34.6307H97.4863V14.9833H104.593V9.24817H97.4863V0.166448ZM31.6379 21.4308V34.6307H23.8111V0.166448H31.6379V12.4239C32.9176 10.3283 35.1947 9.28052 38.4691 9.28052C41.4282 9.27695 43.7713 10.1909 45.4984 12.0222C46.6432 13.2458 47.4063 14.7614 47.6985 16.3919C47.9186 18.0409 48.005 19.7043 47.957 21.3666V34.6307H40.1577V21.6343C40.1577 18.1036 38.7588 16.3383 35.961 16.3383C33.0789 16.3383 31.6379 18.0412 31.6379 21.4308Z"
          fill="url(#paint0_linear_463_146)"
        />
      </g>
      <g filter="url(#filter0_i_463_146)">
        <path
          d="M110.558 25.3279C111.257 25.3279 111.857 25.4494 112.358 25.6923C112.867 25.9277 113.254 26.2618 113.52 26.6946C113.793 27.1275 113.93 27.6324 113.93 28.2095C113.93 28.7866 113.793 29.2915 113.52 29.7243C113.254 30.1572 112.867 30.4951 112.358 30.738C111.857 30.9734 111.257 31.0911 110.558 31.0911H106.822V29.3485H110.444C110.854 29.3485 111.177 29.2498 111.412 29.0523C111.648 28.8473 111.766 28.5664 111.766 28.2095C111.766 27.8526 111.648 27.5755 111.412 27.378C111.177 27.173 110.854 27.0705 110.444 27.0705H107.016L107.984 26.0682V33.8702H105.831V25.3279H110.558ZM116.9 32.1504V30.4077H122.8V32.1504H116.9ZM121.297 25.3279L125.237 33.8702H122.948L119.565 26.2277H120.226L116.854 33.8702H114.554L118.506 25.3279H121.297ZM126.641 31.0797H128.817C128.855 31.3379 128.972 31.5657 129.17 31.7631C129.367 31.9605 129.629 32.1124 129.956 32.2187C130.29 32.325 130.677 32.3782 131.117 32.3782C131.748 32.3782 132.241 32.2908 132.598 32.1162C132.963 31.9416 133.145 31.6948 133.145 31.3759C133.145 31.1329 133.038 30.9468 132.826 30.8178C132.621 30.6811 132.234 30.5824 131.664 30.5216L130.013 30.3508C128.866 30.2369 128.035 29.9711 127.518 29.5535C127.009 29.1359 126.755 28.5664 126.755 27.845C126.755 27.2755 126.922 26.7896 127.256 26.3871C127.598 25.9847 128.073 25.6772 128.68 25.4645C129.295 25.2519 130.013 25.1456 130.833 25.1456C131.645 25.1456 132.363 25.2633 132.985 25.4987C133.608 25.7341 134.105 26.0606 134.477 26.4782C134.849 26.8959 135.051 27.3856 135.081 27.9475H132.906C132.875 27.7121 132.769 27.5147 132.587 27.3553C132.412 27.1882 132.173 27.0591 131.869 26.968C131.573 26.8693 131.216 26.8199 130.798 26.8199C130.221 26.8199 129.762 26.9035 129.42 27.0705C129.086 27.23 128.919 27.4616 128.919 27.7653C128.919 27.9931 129.018 28.1715 129.215 28.3006C129.42 28.4297 129.781 28.5246 130.297 28.5854L132.04 28.779C132.837 28.8625 133.475 28.9954 133.953 29.1776C134.432 29.3599 134.777 29.6104 134.99 29.9294C135.203 30.2483 135.309 30.6507 135.309 31.1367C135.309 31.7214 135.13 32.2339 134.774 32.6743C134.424 33.1071 133.931 33.445 133.293 33.688C132.663 33.931 131.926 34.0525 131.083 34.0525C130.21 34.0525 129.443 33.9272 128.782 33.6766C128.129 33.426 127.613 33.0805 127.233 32.6401C126.861 32.1921 126.664 31.672 126.641 31.0797ZM137.496 31.0797H139.671C139.709 31.3379 139.827 31.5657 140.024 31.7631C140.222 31.9605 140.484 32.1124 140.81 32.2187C141.144 32.325 141.532 32.3782 141.972 32.3782C142.602 32.3782 143.096 32.2908 143.453 32.1162C143.817 31.9416 143.999 31.6948 143.999 31.3759C143.999 31.1329 143.893 30.9468 143.68 30.8178C143.475 30.6811 143.088 30.5824 142.519 30.5216L140.867 30.3508C139.721 30.2369 138.889 29.9711 138.373 29.5535C137.864 29.1359 137.61 28.5664 137.61 27.845C137.61 27.2755 137.777 26.7896 138.111 26.3871C138.453 25.9847 138.927 25.6772 139.535 25.4645C140.15 25.2519 140.867 25.1456 141.687 25.1456C142.5 25.1456 143.217 25.2633 143.84 25.4987C144.463 25.7341 144.96 26.0606 145.332 26.4782C145.704 26.8959 145.905 27.3856 145.936 27.9475H143.76C143.73 27.7121 143.624 27.5147 143.441 27.3553C143.267 27.1882 143.027 27.0591 142.724 26.968C142.428 26.8693 142.071 26.8199 141.653 26.8199C141.076 26.8199 140.617 26.9035 140.275 27.0705C139.941 27.23 139.774 27.4616 139.774 27.7653C139.774 27.9931 139.872 28.1715 140.07 28.3006C140.275 28.4297 140.636 28.5246 141.152 28.5854L142.895 28.779C143.692 28.8625 144.33 28.9954 144.808 29.1776C145.286 29.3599 145.632 29.6104 145.845 29.9294C146.057 30.2483 146.163 30.6507 146.163 31.1367C146.163 31.7214 145.985 32.2339 145.628 32.6743C145.279 33.1071 144.785 33.445 144.147 33.688C143.517 33.931 142.781 34.0525 141.938 34.0525C141.065 34.0525 140.298 33.9272 139.637 33.6766C138.984 33.426 138.468 33.0805 138.088 32.6401C137.716 32.1921 137.519 31.672 137.496 31.0797Z"
          fill="url(#paint1_linear_463_146)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_463_146"
          x="105.832"
          y="25.1456"
          width="40.532"
          height="9.10686"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.2" dy="0.2" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_463_146"
          />
        </filter>
        <linearGradient
          id="paint0_linear_463_146"
          x1="1.65465"
          y1="43.1073"
          x2="32.2422"
          y2="-30.1156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42307D" />
          <stop offset="1" stopColor="#7F56D9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_463_146"
          x1="105"
          y1="26.0202"
          x2="146.913"
          y2="36.8567"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#101010" stopOpacity="0.72" />
          <stop offset="0.481998" stopColor="#282828" stopOpacity="0.518002" />
          <stop offset="1" stopColor="#101010" stopOpacity="0.67" />
        </linearGradient>
        <clipPath id="clip0_463_146">
          <rect
            width="106"
            height="43"
            fill="white"
            transform="translate(0 0.107544)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
